/**
 * 受注（回収・積替・搬入）
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      /* 取引先（排出）事業者ID */
      supplier_id: null,
      supplier_type: null,
      /* 取引先（排出）事業場ID */
      supplier_location_id: null,
      /* 取引先（排出）事業場コード */
      supplier_location_code: null,
      /* 運搬担当者 */
      report_transport_user_id: null,
      report_transport_user_name: null,

      /* 取引先（収運・処分）業者ID */
      supplier_trader_id: null,
      supplier_trader_type: null,
      /* 取引先（収運・処分）事業場ID */
      supplier_trader_location_id: null,
      /* 取引先（収運・処分）事業場コード */
      supplier_trader_location_code: null,

      /* 受注種別 */
      order_type: null,
      /* 回収日なし */
      collected_date_type: null,
      /* 回収・積替・搬入日(開始日) */
      collected_start_date: null,
      /* 回収・積替・搬入日(終了) */
      collected_end_date: null,

      /* DXE起票担当者 */
      vote_staff: null,
      /* 排出者承認 */
      approval_state: null,
      /* ドライバー */
      driver_id: null,
      driver_name: null,

      /* 受注番号 */
      order_number: null,
      /* 依頼番号有無 */
      request_number_flag: null,
      /* 依頼番号 */
      request_number: null,
      /* 取引番号有無 */
      deal_number_flag: null,
      /* 取引番号 */
      deal_number: null,
      /* 廃棄物の名称 */
      waste_name: null,

      /* マニフェスト区分 */
      manifest_type: null,
      /* 運搬先 */
      keyword: null,
      /* 検索キーワード */
      search_keyword: null,
      /* 表示順 */
      sort_type: "updated_date_desc",

      /* マニフェスト検索キーワード */
      manifest_search_keyword: null,
      /* 排出事業場コード */
      location_code: null,
      /* 排出事業場名 */
      location_name: null,
      /* 運搬ルート */
      transport_route_id: null,

      status: null,
      target_date: null,
      plan_date: null,

      limit: 50,
    },
    selectableTab: 0,
  }
}

const order_accept = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 受注一覧
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param subscriber_number
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { conditions, selectable_tab, page, limit }) {
      dispatch("saveCondition", { condition: conditions, selectable_tab: selectable_tab, limit: limit });
      const params = {
        ...state.condition,
        limit: limit,
        page: page,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_ORDER_ACCEPT_PAGINATION, { content })
          resolve(content)
        })
      })
    },
    /**
     * 受注詳細
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    saveCondition ( { commit, state }, { condition, selectable_tab, limit } = {} ) {

      const _supplier_id = (condition.supplier_id !== undefined) ? condition.supplier_id : state.condition.supplier_id;
      const _supplier_type = (condition.supplier_type !== undefined) ? condition.supplier_type : state.condition.supplier_type;
      const _supplier_location_id = (condition.supplier_location_id !== undefined) ? condition.supplier_location_id : state.condition.supplier_location_id;
      const _supplier_location_code = (condition.supplier_location_code !== undefined) ? condition.supplier_location_code : state.condition.supplier_location_code;
      const _report_transport_user_id = (condition.report_transport_user_id !== undefined) ? condition.report_transport_user_id : state.condition.report_transport_user_id;
      const _report_transport_user_name = (condition.report_transport_user_name !== undefined) ? condition.report_transport_user_name : state.condition.report_transport_user_name;

      const _supplier_trader_id = (condition.supplier_trader_id !== undefined) ? condition.supplier_trader_id : state.condition.supplier_trader_id;
      const _supplier_trader_type = (condition.supplier_trader_type !== undefined) ? condition.supplier_trader_type : state.condition.supplier_trader_type;
      const _supplier_trader_location_id = (condition.supplier_trader_location_id !== undefined) ? condition.supplier_trader_location_id : state.condition.supplier_trader_location_id;
      const _supplier_trader_location_code = (condition.supplier_trader_location_code !== undefined) ? condition.supplier_trader_location_code : state.condition.supplier_trader_location_code;

      const _order_type = (condition.order_type !== undefined) ? condition.order_type : state.condition.order_type;
      const _collected_date_type = (condition.collected_date_type !== undefined) ? condition.collected_date_type : state.condition.collected_date_type;
      const _collected_start_date = (condition.collected_start_date !== undefined) ? condition.collected_start_date : state.condition.collected_start_date;
      const _collected_end_date = (condition.collected_end_date !== undefined) ? condition.collected_end_date : state.condition.collected_end_date;

      const _vote_staff = (condition.vote_staff !== undefined) ? condition.vote_staff : state.condition.vote_staff;
      const _approval_state = (condition.approval_state !== undefined) ? condition.approval_state : state.condition.approval_state;
      const _driver_id = (condition.driver_id !== undefined) ? condition.driver_id : state.condition.driver_id;
      const _driver_name = (condition.driver_name !== undefined) ? condition.driver_name : state.condition.driver_name;

      const _order_number = (condition.order_number !== undefined) ? condition.order_number : state.condition.order_number;
      const _request_number_flag = (condition.request_number_flag !== undefined) ? condition.request_number_flag : state.condition.request_number_flag;
      const _request_number = (condition.request_number !== undefined) ? condition.request_number : state.condition.request_number;
      const _deal_number_flag = (condition.deal_number_flag !== undefined) ? condition.deal_number_flag : state.condition.deal_number_flag;
      const _deal_number = (condition.deal_number !== undefined) ? condition.deal_number : state.condition.deal_number;
      const _waste_name = (condition.waste_name !== undefined) ? condition.waste_name : state.condition.waste_name;

      const _manifest_type = (condition.manifest_type !== undefined) ? condition.manifest_type : state.condition.manifest_type;
      const _keyword = (condition.keyword !== undefined) ? condition.keyword : state.condition.keyword;
      const _search_keyword = (condition.search_keyword !== undefined) ? condition.search_keyword : state.condition.search_keyword;
      const _sort_type = (condition.sort_type !== undefined) ? condition.sort_type : state.condition.sort_type;

      const _manifest_search_keyword = (condition.manifest_search_keyword !== undefined) ? condition.manifest_search_keyword : state.condition.manifest_search_keyword;
      const _location_code = (condition.location_code !== undefined) ? condition.location_code : state.condition.location_code;
      const _location_name = (condition.location_name !== undefined) ? condition.location_name : state.condition.location_name;
      const _transport_route_id = (condition.transport_route_id !== undefined) ? condition.transport_route_id : state.condition.transport_route_id;

      const _status = (condition.status !== undefined) ? condition.status : state.condition.status;
      const _target_date = (condition.target_date !== undefined) ? condition.target_date : state.condition.target_date;
      const _plan_date = (condition.plan_date !== undefined) ? condition.plan_date : state.condition.plan_date;

      const _limit = limit !== undefined ? limit : state.condition.limit;

      const params = {
        supplier_id: _supplier_id,
        supplier_type: _supplier_type,
        supplier_location_id: _supplier_location_id,
        supplier_location_code: _supplier_location_code,
        report_transport_user_id: _report_transport_user_id,
        report_transport_user_name: _report_transport_user_name,

        supplier_trader_id: _supplier_trader_id,
        supplier_trader_type: _supplier_trader_type,
        supplier_trader_location_id: _supplier_trader_location_id,
        supplier_trader_location_code: _supplier_trader_location_code,

        order_type: _order_type,
        collected_date_type: _collected_date_type,
        collected_start_date: _collected_start_date,
        collected_end_date: _collected_end_date,

        vote_staff: _vote_staff,
        approval_state: _approval_state,
        driver_id: _driver_id,
        driver_name: _driver_name,

        order_number: _order_number,
        request_number_flag: _request_number_flag,
        request_number: _request_number,
        deal_number_flag: _deal_number_flag,
        deal_number: _deal_number,
        waste_name: _waste_name,

        manifest_type: _manifest_type,
        keyword: _keyword,
        search_keyword: _search_keyword,
        sort_type: _sort_type,

        manifest_search_keyword: _manifest_search_keyword,
        location_code: _location_code,
        location_name: _location_name,
        transport_route_id: _transport_route_id,

        status: _status,
        target_date: _target_date,
        plan_date: _plan_date,

        limit: _limit,

      }
      commit(types.DRIVER_ORDER_ACCEPT_CONDITION, { params })
      commit(types.DRIVER_ORDER_ACCEPT_SELECTABLE_TAB, { selectable_tab })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_ORDER_ACCEPT_RESET_CONDITION)
      commit(types.DRIVER_ORDER_ACCEPT_RESET_PAGINATION)
      commit(types.DRIVER_ORDER_ACCEPT_RESET_TAB)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_ORDER_ACCEPT_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_ORDER_ACCEPT_SELECTABLE_TAB](state, { selectable_tab }) {
      state.selectableTab = selectable_tab;
    },
    [types.DRIVER_ORDER_ACCEPT_RESET_TAB](state) {
      state.selectableTab = 0;
    },
    [types.DRIVER_ORDER_ACCEPT_CONDITION] (state, { params }) {
      Object.assign(state.condition, params);
    },
    [types.DRIVER_ORDER_ACCEPT_RESET_CONDITION] (state) {
      state.selectableTab = 0;
      Object.assign(state.condition, getDefaultState().condition);
    },
    [types.DRIVER_ORDER_ACCEPT_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_ORDER_ACCEPT_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
  },

}

export default order_accept
